export default __webpack_public_path__ + "static/media/f-1.7656771a.png";